// Base database utilities: re-export the proxy so other modules can share it.
import { sql as proxySql, checkDatabaseConnection as proxyCheck, sqlRaw as proxySqlRaw } from '../db-proxy';

// Friendly exports used by the rest of the data layer.
export const sql = proxySql;
export const checkDatabaseConnection = proxyCheck;
export const sqlRaw = proxySqlRaw;
